import { useState, useEffect, useRef, MutableRefObject } from "react";

interface useFullscreenImageProps {
  isImgOpen: boolean;
  openImage: () => void;
  closeImage: () => void;
  containerRef: MutableRefObject<HTMLDivElement | null>;
}

const useFullscreenImage = (): useFullscreenImageProps => {
  const [isImgOpen, setIsImgOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const openImage = () => setIsImgOpen(true);
  const closeImage = () => setIsImgOpen(false);

  //HANDLING THE CLICKING AND OVERFLOW OF THE BODY ========================
  const handleClickOutside = (e: MouseEvent) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(e.target as Node)
    ) {
      setIsImgOpen(false);
      document.body.style.overflow = "auto";
    }
  };
  //watch for window resize and update the overflow of the body
  //disable fullscreen if the window width is less than 768px
  const handleResize = () => {
    if (window.innerWidth < 768 && isImgOpen) {
      document.body.style.overflow = "auto";
      setIsImgOpen(false);
    } else if (window.innerWidth >= 768 && isImgOpen) {
      document.body.style.overflow = "hidden";
    }
  };
  //watch for the isImgOpen state and add or remove event listeners
  useEffect(() => {
    if (isImgOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("resize", handleResize);

      if (window.innerWidth >= 768) {
        document.body.style.overflow = "hidden";
      }
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "auto";
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "auto";
    };
  });

  return { isImgOpen, openImage, closeImage, containerRef };
};

export default useFullscreenImage;
